import { render, staticRenderFns } from "./extensionTermManagement.vue?vue&type=template&id=146b806e&scoped=true"
import script from "./extensionTermManagement.vue?vue&type=script&lang=js"
export * from "./extensionTermManagement.vue?vue&type=script&lang=js"
import style0 from "./extensionTermManagement.vue?vue&type=style&index=0&id=146b806e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146b806e",
  null
  
)

export default component.exports